/* eslint-disable react/display-name */
import * as React from 'react';

const ChevronUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g>
      <path
        d="M8,6.28l-5.84,6.3a1.23,1.23,0,0,1-1.72.07l-.06-.07a1.4,1.4,0,0,1,0-1.92L7.09,3.42a1.26,1.26,0,0,1,1.75-.07.46.46,0,0,1,.07.07l6.71,7.24a1.4,1.4,0,0,1,0,1.92,1.21,1.21,0,0,1-1.71.07l-.07-.07Z"
        style={{ fill: 'inherit' }}
      />
    </g>
  </svg>
);

export default ChevronUp;
